var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDismissRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.2 12.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #B53030;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    className: "cls-1",
    d: "M21.962,15.131v5.831H16.131A1.146,1.146,0,0,0,15,22.094a1.217,1.217,0,0,0,1.131,1.131h5.831v5.737a1.146,1.146,0,0,0,1.131,1.131,1.217,1.217,0,0,0,1.131-1.131V23.225h5.737a1.146,1.146,0,0,0,1.131-1.131,1.067,1.067,0,0,0-1.037-1.131H24.319V15.131A1.146,1.146,0,0,0,23.188,14,1.31,1.31,0,0,0,21.962,15.131Z",
    transform: "translate(5.336 -25.9) rotate(45)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDismissRed);
export default __webpack_public_path__ + "static/media/icon_dismiss_red.fa870babfdc3f8061f12988e3c50565e.svg";
export { ForwardRef as ReactComponent };